import {
  TRANSLATIONS,
  TRANSLATION_NAMESPACE,
} from "@bfc-software/bfc-web-ui/i18n/resources";

export type LanguageKey = keyof typeof TRANSLATIONS;
export type NameSpaceKeys =
  (typeof TRANSLATION_NAMESPACE)[keyof typeof TRANSLATION_NAMESPACE];

export const SUPPORTED_LOCALES: Array<LanguageKey> = ["en"];
export const DEFAULT_LOCALE = "en";
export const cookieName = "i18next";

type Options = {
  lang: string;
  namespace: NameSpaceKeys;
};

export function getOptions({ lang, namespace }: Options) {
  return {
    // debug: true,
    resources: TRANSLATIONS,
    supportedLngs: SUPPORTED_LOCALES,
    fallbackLng: DEFAULT_LOCALE,
    lng: lang,
    ns: namespace,
    interpolation: {
      /**
       * Off because React already escapes everything it renders, so i18next's
       * own escaping is not a second line of defence - it is a corruption.
       * The escaped output is a *string*, and React writes strings into text
       * nodes verbatim rather than decoding entities, so an escaped character
       * reaches the screen as its entity.
       *
       * Left on, i18next's escape table (`&`, `<`, `>`, `"`, `'`, `/`) turned
       * the plan card's `MM/dd/yy p` created date into
       * `Created 09&#x2F;10&#x2F;26 1:59 PM` on screen (SR-342). Any
       * interpolated value carrying one of those characters had the same
       * problem - a selector name with an apostrophe, a route code with a
       * slash - it just had not been noticed yet.
       *
       * `__tests__/i18n/interpolation.test.ts` pins this, and deliberately
       * builds its instance from this function rather than from the one
       * `vite-setup.ts` installs: the harness hard-codes `escapeValue: false`
       * of its own, so a test using it would pass no matter what ships here.
       */
      escapeValue: false,
    },
  };
}
